import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// 🛡️ Global error handler to suppress non-critical errors
// These occur from navigation race conditions and third-party scripts
window.addEventListener('error', (event) => {
  // Suppress generic "Script error" from cross-origin scripts
  if (event.message === 'Script error.' || event.message === 'Script error') {
    console.warn('[Global] Suppressed cross-origin Script error (non-critical)');
    event.preventDefault();
    return true;
  }
  
  // Suppress WebSocket connection errors (non-critical in dev)
  if (event.message && event.message.includes('WebSocket')) {
    console.warn('[Global] Suppressed WebSocket error (non-critical)');
    event.preventDefault();
    return true;
  }
  
  // Suppress "Failed to fetch" errors from navigation race conditions
  if (event.message && event.message.includes('Failed to fetch')) {
    console.warn('[Global] Suppressed fetch error during navigation (non-critical)');
    event.preventDefault();
    return true;
  }
  
  return false;
}, true);

// Also handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const reasonStr = String(reason);
  const reasonMsg = (reason && typeof reason === 'object' && reason.message) || '';
  
  // 🔇 P2 (Fev 2026) — Bruit provenant d'EXTENSIONS Chrome (Grammarly,
  // password managers, traducteurs, AdBlockers, etc.) qui utilisent
  // chrome.runtime.onMessage avec `return true` sans appeler sendResponse.
  // Signature CANONIQUE, externe au code CoachDIA (aucun usage de
  // chrome.runtime.* dans /app/frontend). On supprime la pollution
  // console SANS masquer la moindre erreur applicative.
  // Voir : https://stackoverflow.com/q/53939205
  const EXT_MESSAGE_CHANNEL_NOISE =
    'A listener indicated an asynchronous response by returning true, '
    + 'but the message channel closed before a response was received';
  if (reasonMsg === EXT_MESSAGE_CHANNEL_NOISE || reasonStr.includes(EXT_MESSAGE_CHANNEL_NOISE)) {
    // console.debug uniquement (pas console.warn) → invisible par défaut
    // sauf si le filtre console est ouvert sur le niveau "verbose".
    // eslint-disable-next-line no-console
    console.debug('[ext-noise] Chrome extension async listener closed (external, ignored)');
    event.preventDefault();
    return;
  }
  
  // Suppress errors from posthog, rrweb, analytics, or navigation
  if (reason && (
    reasonStr.includes('posthog') ||
    reasonStr.includes('rrweb') ||
    reasonStr.includes('Script error') ||
    reasonStr.includes('net::ERR_') ||
    reasonStr.includes('Failed to fetch') ||
    reasonStr.includes('AbortError') ||
    reasonStr.includes('ERR_ABORTED') ||
    reasonStr.includes('ERR_CANCELED') ||
    reasonStr.includes('The user aborted')
  )) {
    console.warn('[Global] Suppressed non-critical rejection:', reasonStr.substring(0, 100));
    event.preventDefault();
    return;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // ⚠️ StrictMode disabled to prevent double fetch execution causing "Response body already used" errors
  // This was interfering with voice session API calls in CoachVocal
  <App />
);
